import { useEffect, useState } from "react";
import { FlexCol, FlexRow } from "src/utils/flexLayouts";
import moment from "moment";

import SortIcon from "src/components/ui-icons/table/SortIcon";
import { selectUsers } from "src/modules/users/selector";
import { useAppSelector } from "src/hooks/redux";
import {
  notificationsListName,
  templatesOWDListName,
} from "src/api/config/notifications.config";
import { getItemsRequest } from "src/modules/spItems/api";
import { ListFieldsType, siteUrl } from "src/api/config";
import { urlDefault } from "src/constants";

const OwdEmplyeesTableSingle = (props: any) => {
  const { data, setExportData, setQuery, query, cardVersion } = props;
  const [sortData, setSortData] = useState<any>([]);
  const users: any = useAppSelector(selectUsers);
  const [templatesOWD, setTemplatesOWD] = useState<any>([]);

  function handleClickNotificationCard(
    item: ListFieldsType[typeof notificationsListName]
  ) {
    const newSearchParams = new URLSearchParams(query);
    newSearchParams.set("notificationCard", item.ID.toString());
    setQuery(newSearchParams);
  }

  const [tableHeaderContent, setTableHeaderContent] = useState<any>({
    Expert: {
      title: "Кто провел OWD",
      sort: true,
      width: "12.5%",
      sortDirection: "default",
      sortType: "string",
    },
    Employee: {
      title: "Кому провели OWD",
      sort: true,
      width: "12.5%",
      sortDirection: "default",
      sortType: "string",
    },
    TemplateOWDTitle: {
      title: "Шаблон OWD",
      sort: true,
      width: "10%",
      sortDirection: "default",
      sortType: "string",
    },
    Created: {
      title: "Дата назначения",
      sort: true,
      width: "15%",
      sortDirection: "default",
      sortType: "date",
    },
    Author: {
      title: "Кем назначено",
      sort: true,
      width: "15%",
      sortDirection: "default",
      sortType: "string",
    },
    ReviewDate: {
      title: "Срок проведения",
      sort: true,
      width: "15%",
      sortDirection: "default",
      sortType: "date",
    },
    Status: {
      title: "Статус",
      sort: true,
      width: "10%",
      sortDirection: "default",
      sortType: "string",
    },
    Completed: {
      title: "Дата факта проведения",
      sort: true,
      width: "10%",
      sortDirection: "default",
      sortType: "date",
    },
    Ver: {
      title: "Версия документа",
      sort: false,
      width: "10%",
      sortDirection: "default",
      sortType: "number",
    },
    TestAnswerRate: {
      title: "Результат",
      sort: true,
      width: "10%",
      sortDirection: "default",
      sortType: "number",
    },
  });

  const sortDataHandle = (
    sortField: string,
    sortDirection: string,
    sortType: string
  ) => {
    const tempTableHeaderContent = { ...tableHeaderContent };
    const tempData = [
      ...data.map((item: any) => {
        return {
          ...item,
          ...{
            Expert:
              (users[item.EmployeeEmail.toLowerCase()] &&
                users[item.EmployeeEmail.toLowerCase()]["displayName"]) ||
              "-",
            Employee:
              (item.TestedEmployee &&
                users[item.TestedEmployee.toLowerCase()] &&
                users[item.TestedEmployee.toLowerCase()]["displayName"]) ||
              "-",
            Author:
              (users[item.AuthorEmail.toLowerCase()] &&
                users[item.AuthorEmail.toLowerCase()]["displayName"]) ||
              "-",
            TemplateOWDTitle:
              (item.TemplateOWDID &&
                templatesOWD.filter(
                  (template: any) => template.ID === item.TemplateOWDID
                ).length > 0 &&
                templatesOWD.filter(
                  (template: any) => template.ID === item.TemplateOWDID
                )[0]["Title"]) ||
              "-",
            Status: ((item.Title.includes("Отклонено") && "Отклонено") || (!item.isPass && !item.Title.includes("Отклонено") && item.TestAnswerRate === 0 && "Не проведено") || (!item.isPass && !item.Title.includes("Отклонено") && item.TestAnswerRate > 0 && "Не сдано") || (item.isPass && "Сдано")),
            Ver: ((item.VersionDocument && item.VersionDocument.get_metadata()['Ver']) || (item.Document && item.Document.get_metadata()['Ver']) || 1),
          },
        };
      }),
    ];
    Object.keys(tempTableHeaderContent).map((key: string) => {
      tempTableHeaderContent[key]["sortDirection"] = "default";
    });
    if (sortDirection === "default") {
      tempTableHeaderContent[sortField]["sortDirection"] = "desc";
    }
    if (sortDirection === "desc") {
      tempTableHeaderContent[sortField]["sortDirection"] = "asc";
    }
    if (sortDirection === "asc") {
      tempTableHeaderContent[sortField]["sortDirection"] = "default";
      setSortData([...data]);
    }
    if (sortType === "number") {
      if (tempTableHeaderContent[sortField]["sortDirection"] === "desc") {
        tempData.sort(
          (a: any, b: any) =>
            parseFloat(a[sortField]) - parseFloat(b[sortField])
        );
      }
      if (tempTableHeaderContent[sortField]["sortDirection"] === "asc") {
        tempData.sort(
          (a: any, b: any) =>
            parseFloat(b[sortField]) - parseFloat(a[sortField])
        );
      }
    }
    if (sortType === "string") {
      if (tempTableHeaderContent[sortField]["sortDirection"] === "desc") {
        tempData.sort((a: any, b: any) => {
          return a[sortField].localeCompare(b[sortField]);
        });
      }
      if (tempTableHeaderContent[sortField]["sortDirection"] === "asc") {
        tempData.sort((a: any, b: any) => {
          return b[sortField].localeCompare(a[sortField]);
        });
      }
    }
    if (sortType === "date") {
      if (tempTableHeaderContent[sortField]["sortDirection"] === "desc") {
        const distantFuture = new Date(8640000000000000);
        tempData.sort((a: any, b: any) => {
          let dateA = a[sortField] || distantFuture;
          let dateB = b[sortField] || distantFuture;
          return dateA.getTime() - dateB.getTime();
        });
      }
      if (tempTableHeaderContent[sortField]["sortDirection"] === "asc") {
        const distantFuture = new Date(8640000000000000);
        tempData.sort((a: any, b: any) => {
          let dateA = a[sortField] || distantFuture;
          let dateB = b[sortField] || distantFuture;
          return dateB.getTime() - dateA.getTime();
        });
      }
    }
    setTableHeaderContent({ ...tempTableHeaderContent });
    setSortData([...tempData]);
  };

  useEffect(() => {
    setSortData([...data]);
    const tempTableHeaderContent = { ...tableHeaderContent };
    Object.keys(tempTableHeaderContent).map((key: string) => {
      tempTableHeaderContent[key]["sortDirection"] = "default";
    });
    setTableHeaderContent({ ...tempTableHeaderContent });
  }, [data]);

  useEffect(() => {
    if (sortData.length > 0) {
      let exportColumns: any = [];
      Object.keys(tableHeaderContent).map((key: any) => {
        exportColumns = [
          ...exportColumns,
          {
            header: tableHeaderContent[key]["title"],
            key: key,
            width: 50,
          },
        ];
      });
      exportColumns = [
        ...[
          {
            header: "Уведомление",
            key: "Title",
            width: 50,
          },
        ],
        ...exportColumns,
      ];
      let exportData: any = [];
      sortData.forEach((item: any) => {
        exportData = [
          ...exportData,
          {
            Title: {
              text: item.Title,
              hyperlink: `${siteUrl}/dashboard/1/reports/4?notificationCard=${item.ID}`,
            },
            Expert:
              (users[item.EmployeeEmail.toLowerCase()] &&
                users[item.EmployeeEmail.toLowerCase()]["displayName"]) ||
              "-",
            Employee:
              (item.TestedEmployee &&
                users[item.TestedEmployee.toLowerCase()] &&
                users[item.TestedEmployee.toLowerCase()]["displayName"]) ||
              "-",
            Author:
              (users[item.AuthorEmail.toLowerCase()] &&
                users[item.AuthorEmail.toLowerCase()]["displayName"]) ||
              "-",
            Created: moment(item.Created).format("DD.MM.YYYY"),
            ReviewDate: moment(item.ReviewDate).format("DD.MM.YYYY"),
            Status: ((item.Title.includes("Отклонено") && "Отклонено") || (!item.isPass && !item.Title.includes("Отклонено") && item.TestAnswerRate === 0 && "Не проведено") || (!item.isPass && !item.Title.includes("Отклонено") && item.TestAnswerRate > 0 && "Не сдано") || (item.isPass && "Сдано")),
            Completed:
              (item.Completed && moment(item.Completed).format("DD.MM.YYYY")) ||
              "-",
            TestAnswerRate:
              (item.TestAnswerRate && item.TestAnswerRate + "%") || "-",
            Ver: ((item.VersionDocument && item.VersionDocument.get_metadata()['Ver']) || (item.Document && item.Document.get_metadata()['Ver']) || 1),
            TemplateOWDTitle:
              (item.TemplateOWDID &&
                templatesOWD.filter(
                  (template: any) => template.ID === item.TemplateOWDID
                ).length > 0 &&
                templatesOWD.filter(
                  (template: any) => template.ID === item.TemplateOWDID
                )[0]["Title"]) ||
              "-",
          },
        ];
      });
      setExportData({ columns: [...exportColumns], data: [...exportData] });
    }
  }, [sortData, users]);

  useEffect(() => {
    getItemsRequest({ listName: templatesOWDListName }).then((results) => {
      setTemplatesOWD([...results.items]);
    });
  }, []);

  return (
    <FlexCol className="w-full">
      <FlexCol className="relative">
        <FlexCol
          id="owd_calendar_wrapper"
          className="relative pb-5 overflow-x-auto bg-white rounded-lg table-custom shadow-custom scrollbar scrollbar-thumb-rounded-lg scrollbar-h-2 scrollbar-w-2 scrollbar-thumb-[#D1D5DB] max-h-[calc(100vh-500px)] min-h-[60px]"
        >
          <FlexRow className="pb-5 sticky-custom max-h-[65px] min-w-[1500px] bg-white pt-5 px-10 gap-5 z-10">
            {Object.keys(tableHeaderContent).map((fieldKey) => {
              const key: string = fieldKey;
              return (
                <TableHeaderColumn
                  key={fieldKey}
                  sortField={fieldKey}
                  tableHeaderContent={tableHeaderContent[key]}
                  sortDataHandle={sortDataHandle}
                />
              );
            })}
          </FlexRow>
          <FlexCol className="divide-y grow min-w-[1500px] px-10">
            {sortData.map((item: any) => {
              return (
                <FlexRow
                  onClick={() => handleClickNotificationCard(item)}
                  className="py-4 w-full -mx-2 px-2 gap-5 cursor-pointer hover:bg-[#F3F4F6] hover:bg-opacity-50"
                  key={item.ID}
                >
                  <FlexCol
                    style={{ width: "12.5%" }}
                    className=" break-words text-[#637381]"
                  >
                    {(users[item.EmployeeEmail.toLowerCase()] &&
                      users[item.EmployeeEmail.toLowerCase()]["displayName"]) ||
                      "-"}
                  </FlexCol>
                  <FlexCol style={{ width: "12.5%" }} className="text-[#637381]">
                    {(item.TestedEmployee &&
                      users[item.TestedEmployee.toLowerCase()] &&
                      users[item.TestedEmployee.toLowerCase()][
                      "displayName"
                      ]) ||
                      "-"}
                  </FlexCol>
                  <FlexCol
                    style={{ width: "10%" }}
                    className="break-words text-[#637381]"
                  >
                    {(item.TemplateOWDID &&
                      templatesOWD.filter(
                        (template: any) => template.ID === item.TemplateOWDID
                      ).length > 0 &&
                      templatesOWD.filter(
                        (template: any) => template.ID === item.TemplateOWDID
                      )[0]["Title"]) ||
                      "-"}
                  </FlexCol>
                  <FlexCol
                    style={{ width: "15%" }}
                    className="break-words text-[#637381]"
                  >
                    {moment(item.Created).format("DD.MM.YYYY")}
                  </FlexCol>
                  <FlexCol
                    style={{ width: "15%" }}
                    className="break-words text-[#637381]"
                  >
                    {(users[item.AuthorEmail.toLowerCase()] &&
                      users[item.AuthorEmail.toLowerCase()]["displayName"]) ||
                      "-"}
                  </FlexCol>
                  <FlexCol
                    style={{ width: "15%" }}
                    className="break-words text-[#637381]"
                  >
                    {moment(item.ReviewDate).format("DD.MM.YYYY")}
                  </FlexCol>
                  <FlexCol
                    style={{ width: "10%" }}
                    className="break-words text-[#637381]"
                  >
                    {((item.Title.includes("Отклонено") && "Отклонено") || (!item.isPass && !item.Title.includes("Отклонено") && item.TestAnswerRate === 0 && "Не проведено") || (!item.isPass && !item.Title.includes("Отклонено") && item.TestAnswerRate > 0 && "Не сдано") || (item.isPass && "Сдано"))}
                  </FlexCol>
                  <FlexCol
                    style={{ width: "10%" }}
                    className="break-words text-[#637381]"
                  >
                    {(item.Completed &&
                      moment(item.Completed).format("DD.MM.YYYY")) ||
                      "-"}
                  </FlexCol>
                  <FlexCol
                    style={{ width: "10%" }}
                    className="break-words text-[#637381]"
                  >
                    {((item.VersionDocument && item.VersionDocument.get_metadata()['Ver']) || (item.Document && item.Document.get_metadata()['Ver']) || 1)}
                  </FlexCol>
                  <FlexCol
                    style={{ width: "10%" }}
                    className="break-words text-[#637381]"
                  >
                    {(item.TestAnswerRate && item.TestAnswerRate + "%") || "-"}
                  </FlexCol>
                </FlexRow>
              );
            })}
          </FlexCol>
        </FlexCol>
      </FlexCol>
    </FlexCol>
  );
};

export default OwdEmplyeesTableSingle;

export function TableHeaderColumn({
  tableHeaderContent,
  sortDataHandle,
  sortField,
}: any) {
  return (
    <FlexCol
      className="select-none"
      style={{ width: tableHeaderContent.width }}
    >
      <FlexRow className="gap-x-2 w-full">
        {tableHeaderContent.icon && (
          <FlexCol>{tableHeaderContent.icon}</FlexCol>
        )}
        <FlexCol className="font-medium whitespace-pre-line">
          {tableHeaderContent.title}
        </FlexCol>
        {tableHeaderContent.sort && (
          <FlexCol
            className="w-auto cursor-pointer"
            onClick={() =>
              sortDataHandle(
                sortField,
                tableHeaderContent.sortDirection,
                tableHeaderContent.sortType
              )
            }
          >
            <SortIcon sortDirection={tableHeaderContent.sortDirection} />
          </FlexCol>
        )}
      </FlexRow>
    </FlexCol>
  );
}
